// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "hashed-1/" + (chunkId === 20071 ? "griffel" : chunkId) + "-" + {20071: "5889385755",50641: "42ef90fcb1",55028: "52714c4833",57167: "81d35eec74",}[chunkId] + ".css"
}